import React, { useState, useEffect } from "react";
import Video from "../../videos/video.mp4";
import { Button } from "../ButtonElements";
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
} from "./HeroElements";

const HeroSection = () => {
  const [hover, setHover] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const onHover = () => {
    setHover(!hover);
  };

  return (
    <HeroContainer id="hero">
      <HeroBg>
        {isMobile ? (
          <img 
            src={require('../../images/statichero.png')} 
            alt="Background"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              opacity: 0.3
            }}
          />
        ) : (
          <VideoBg 
            autoPlay 
            loop 
            muted 
            playsinline 
            disablePictureInPicture 
            src={Video} 
            type="video/mp4"
            preload="auto"
            defaultMuted
          />
        )}
      </HeroBg>
      <HeroContent>
        <HeroH1>Welcome to Minute Growth</HeroH1>
        <HeroP>
          SKIP THE LINE. <br></br> Pay to go viral with Minute Growth's award winning marketing services.
        </HeroP>
        <HeroBtnWrapper>
          <Button
            to="contact"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
            onMouseEnter={onHover}
            onMouseLeave={onHover}
            primary="true"
            dark="true"
          >
            Start a Campaign Now {hover ? <ArrowForward /> : <ArrowRight />}
          </Button>
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
};

// random test 

export default HeroSection;
